/* eslint-disable max-len */
/* eslint-disable  react/jsx-indent */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import useDebounce from 'modules/common/components/UseDebounce';
import ToggleFetcherTimer from 'modules/common/components/ToggleFetcherTimer';
import * as actions from './action';
import * as c from './constant';
import TransactionContent from './TransactionContent';
import TransmittalModal from './modal/TransmittalModal';
import DateTransmittalModal from './modal/DateTransmittalModal';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'T_BPLS',
  transaction_type: 'NEW',
};


const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'FOR RESUBMISSION', value: 'FOR RESUBMISSION' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR DELIVERY', value: 'FOR DELIVERY' },
  { label: 'RECEIVED', value: 'RECEIVED' },
];

function TransactionContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  showTransaction,
  history,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'T_BPLS',
    transaction_type: 'NEW',
    q: formData.keyword,
    sort_by: 'asc',
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);

  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
    });
    getTransactionList({ ...filter, transaction_status: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({
        module_type: 'T_BPLS',
        q: formData.keyword,
        transaction_type: 'NEW',
      });
    } else {
      getTransactionList({
        module_type: 'T_BPLS',
        transaction_type: 'NEW',
      });
    }
  }, [debouncedSearchTerm]);

  const onGenerate = e => {
    e.preventDefault();

    setFormData({
      ...formData,
      isLoading: true,
      generate: true,
      url: '',
    });

    const src = `${process.env.REACT_APP_WS}${c.BPLS_TRANSMITTAL
      }?bearer_token=${token}&date_issued=${_.get(
        formData,
        'date_issued'
      )}&serial_number=${_.get(formData, 'serial_number')}&email=${_.get(
        authProfile,
        'email'
      )}&type=NEW`;

    setTimeout(() => {
      window.location.href = src;
      setFormData({
        ...formData,
        isLoading: false,
        generate: false,
      });
    }, 100);

    setTimeout(() => {
      const id = history.location.pathname.replace('/bpls/new/', '');
      showTransaction(id);
    }, 2000);
  };

  const reprintTransmittal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransmittalModal type="NEW" />,
      title: null,
      modalSize: 'modal-sm',
    });
  };

  const dateTransmittal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DateTransmittalModal type="NEW" />,
      title: null,
      modalSize: 'modal-sm',
    });
  };

  const onCallbackTimer = () => {
    getTransactionList({
      module_type: 'T_BPLS',
      q: formData.keyword,
      transaction_status: filter.transaction_status,
      transaction_type: 'NEW',
    });
  };

  const bplsNotification = (item) => {
    return ['T_BPLS'].indexOf(_.get(item, 'attributes.module_type')) > -1 &&
      ['NEW', 'RENEWAL'].indexOf(_.get(item, 'attributes.transaction_type')) > -1 &&
      _.get(item, 'attributes.transaction_status') === 'FOR CHECKING' &&
      _.get(item, 'attributes.is_start_assessment') === 0
  }

  return (
    <div className="card-content-listing" style={{ paddingTop: '0px' }}>
      {Acl(permissions, ['VIEW TRANSMITTAL']) && (
        <div className="transmital">
          <ToggleFetcherTimer callback={onCallbackTimer} />
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div className="ml-auto">
              <form onSubmit={onGenerate}>
                <button
                  disabled={_.get(formData, 'isLoading')}
                  type="submit"
                  className="mt-3 btn gen-btn btn-success font-weight-bold"
                >
                  {_.get(formData, 'isLoading') ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    <>
                      PRINT TRANSMITTAL &nbsp;
                      <i className="fas fa-print" />
                    </>
                  )}
                </button>
              </form>
            </div>
            <div className="ml-3">
              <form onSubmit={reprintTransmittal}>
                <button
                  disabled={_.get(formData, 'isLoading')}
                  type="submit"
                  className="mt-3 btn gen-btn btn-success font-weight-bold"
                >
                  {_.get(formData, 'isLoading') ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    <>
                      REPRINT TRANSMITTAL &nbsp;
                      <i className="fas fa-print" />
                    </>
                  )}
                </button>
              </form>
            </div>
            <div className="ml-3">
              <form onSubmit={dateTransmittal}>
                <button
                  disabled={_.get(formData, 'isLoading')}
                  type="submit"
                  className="mt-3 btn gen-btn btn-success font-weight-bold"
                >
                  {_.get(formData, 'isLoading') ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    <>
                      FILTER DATE - PRINT TRANSMITTAL &nbsp;
                      <i className="fas fa-print" />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={statusOptions}
            notificationListConfig={bplsNotification}
            moduleName="New Applications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            renderItem={item => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'included.module.attributes.business_name')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.module.attributes.bin') || ''}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <TransactionContent UpdateData={UpdateData} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

TransactionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionContainer);
